import React, { useState, useEffect, useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useStatesUIContext } from "../StatesUIContext";
import * as countryCrud from "../../../_redux/countries/countriesCrud";

const prepareFilter = (queryParams, values) => {
  const { country_id, searchText } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  if (country_id && country_id !== "") {
    filter.country_id = country_id;
  }
  if (searchText && searchText.trim() !== "") {
    filter.name = searchText.trim();
  }

  newQueryParams.filter = filter;
  return newQueryParams;
};

export function StatesFilter({ listLoading }) {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    countryCrud.findCountries({ pageSize: 1000, pageNumber: 1, sortField: 'name', sortOrder: 'ASC' }).then(res => {
      if (res.data && res.data.entities) {
        setCountries(res.data.entities);
      }
    }).catch(err => console.error("Error fetching countries", err));
  }, []);

  // States UI Context
  const statesUIContext = useStatesUIContext();
  const statesUIProps = useMemo(() => {
    return {
      setQueryParams: statesUIContext.setQueryParams,
      queryParams: statesUIContext.queryParams,
    };
  }, [statesUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(statesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, statesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      statesUIProps.setQueryParams(newQueryParams);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          country_id: statesUIProps.queryParams.filter?.country_id || "",
          searchText: statesUIProps.queryParams.filter?.name || "",
        }}
        enableReinitialize={true}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          setFieldValue,
          resetForm,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right mb-4">
            <div className="form-group row align-items-center">
              <div className="col-lg-3 col-md-4 mb-2">
                <select
                  className="form-control"
                  name="country_id"
                  value={values.country_id}
                  onChange={(e) => {
                    const val = e.target.value;
                    setFieldValue("country_id", val);
                    applyFilter({ ...values, country_id: val });
                  }}
                >
                  <option value="">All Countries</option>
                  {countries.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.name}
                    </option>
                  ))}
                </select>
                <small className="form-text text-muted">
                  Filter by <b>Country</b>
                </small>
              </div>

              <div className="col-lg-3 col-md-4 mb-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchText"
                  placeholder="Search state name..."
                  onBlur={handleBlur}
                  value={values.searchText}
                  onChange={(e) => {
                    const val = e.target.value;
                    setFieldValue("searchText", val);
                    applyFilter({ ...values, searchText: val });
                  }}
                />
                <small className="form-text text-muted">
                  <b>Search</b> by name
                </small>
              </div>

              {(values.country_id || values.searchText) && (
                <div className="col-lg-2 col-md-4 mb-2">
                  <button
                    type="button"
                    className="btn btn-light-danger btn-sm"
                    onClick={() => {
                      resetForm({ values: { country_id: "", searchText: "" } });
                      applyFilter({ country_id: "", searchText: "" });
                    }}
                  >
                    <i className="fa fa-times mr-1"></i> Clear Filters
                  </button>
                </div>
              )}
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}

